import type { BatchItem } from '@api/hooks/useBatch.ts';
import { Chip, DocumentIcon, Typography } from '@gurupay/gp-ui-library';
import {
	batchStatusColorConfig,
	deletableStatuses,
} from '@pages/batch-operations/utils.ts';
import { formatNumberAmount } from '@utils/utils.ts';
import type { TFunction } from 'i18next';

import { DeleteFullBatch } from './DeleteFullBatch.tsx';

export const HeaderRenderers = (t: TFunction, isDeleteDisabled: boolean) => ({
	file: ({ fileName }: BatchItem) => (
		<div className="flex gap-space-8">
			<DocumentIcon className="text-brand-primary-600 min-w-5" />
			<Typography
				className="font-bold flex gap-space-8 items-center break-all min-w-[300px] lg:w-full"
				level="small-text"
			>
				{fileName}
			</Typography>
		</div>
	),

	uploaded: ({ uploadDate }: BatchItem) => (
		<Typography
			className="font-medium inline-block w-[150px] text-neutral-800"
			level="small-text"
		>
			{uploadDate}
		</Typography>
	),

	operations: ({ resolvedOperationsCount, operationsCount }: BatchItem) => (
		<Typography className="font-medium" level="small-text">
			{resolvedOperationsCount ?? operationsCount}
		</Typography>
	),

	status: ({ status }: BatchItem) => (
		<Chip
			color={batchStatusColorConfig[status]}
			label={t(`paymentStatus.${status.toLocaleLowerCase()}`)}
			size="medium"
		/>
	),

	amount: ({ resolvedAmount, totalAmount }: BatchItem) => (
		<Typography className="font-bold" level="small-text">
			{formatNumberAmount((resolvedAmount ?? totalAmount).toFixed(2))}
		</Typography>
	),

	delete: ({ status, uuid, fileName }: BatchItem) =>
		deletableStatuses.includes(status) ? (
			<DeleteFullBatch disabled={isDeleteDisabled} fileName={fileName} id={uuid} />
		) : null,
});
